import { appConfig } from 'config'
const DefaultImage = `${appConfig.publicAssetEndpoint}/etc/logo-default.png`
//config constant for banner
export enum BannerStatus {
  PUBLISH = 'publish',
  UNPUBLISH = 'unpublish',
}

export enum BannerStatusText {
  PUBLISH = 'เปิดใช้งาน',
  UNPUBLISH = 'ปิดใช้งาน',
}

export enum BannerPosition {
  SLIDER = 'slider',
  PRODUCT = 'product',
}

export enum BannerPositionText {
  SLIDER = 'สไลด์เดอร์',
  PRODUCT = 'หน้าแสดงสินค้า',
}

export enum BannerType {
  CONTENT = 'content',
  LINK = 'link',
}

export enum BannerTypeText {
  CONTENT = 'เนื้อหา',
  LINK = 'ระบุลิงค์',
}

//config menu for banner
export const menuBannerPosition = [
  {
    name: BannerPositionText.SLIDER,
    value: BannerPosition.SLIDER,
  },
  {
    name: BannerPositionText.PRODUCT,
    value: BannerPosition.PRODUCT,
  },
]

export const menuBannerType = [
  {
    name: BannerTypeText.CONTENT,
    value: BannerType.CONTENT,
  },
  {
    name: BannerTypeText.LINK,
    value: BannerType.LINK,
  },
]

//config constant for coupon
export enum CouponType {
  AMOUNT = 'amount',
  PERCENT = 'percent',
}

export enum CouponTypeText {
  AMOUNT = 'จำนวนเงิน (บาท)',
  PERCENT = 'เปอร์เซ็นต์',
}

export enum CouponMinimumType {
  UNLIMIT = 'unlimit',
  MINIMUM = 'minimum',
}

export enum CouponMinimumTypeText {
  UNLIMIT = 'ไม่มีขั้นต่ำ',
  MINIMUM = 'เมื่อซื้อขั้นต่ำ',
}

export enum StatusText {
  PUBLISH = 'เปิดใช้งาน',
  UNPUBLISH = 'ปิดใช้งาน',
}

export enum CampaignType {
  COUPON = 'coupon',
}

export enum CampaignEventType {
  REGISTER = 'register',
}

export enum CampaignWithProduct {
  ALL = 'all',
  VERIFY = 'verify',
}

export const menuCouponType = [
  {
    name: CouponTypeText.AMOUNT,
    value: CouponType.AMOUNT,
  },
  // {
  //   name: CouponTypeText.PERCENT,
  //   value: CouponType.PERCENT,
  // },
]

export const menuCouponStatusFilter = [
  {
    name: 'แคมเปญยังไม่ถึงช่วงเวลาแจกคูปอง',
    value: 'not_start',
  },
  {
    name: 'แคมเปญอยู่ในช่วงเวลากำหนดแจกคูปอง',
    value: 'between',
  },
  {
    name: 'แคมเปญหมดอายุ',
    value: 'expire',
  },
]

//config constant for merchant
export enum MerchantType {
  INDIVIDUAL = 'individual',
  COPORATE = 'coporate',
}

export enum MerchantStatus {
  APPROVE = 'approve',
  WAITING = 'waiting',
  REJECT = 'reject',
  ALL = '',
}

export enum MerchantStatusText {
  APPROVE = 'อนุมัติ',
  WAITING = 'รออนุมัติ',
  REJECT = 'ไม่อนุมัติ',
  ALL = 'ทั้งหมด',
}

export const menuMerchantStatus = [
  {
    name: MerchantStatusText.ALL,
    value: MerchantStatus.ALL,
  },
  {
    name: MerchantStatusText.APPROVE,
    value: MerchantStatus.APPROVE,
  },
  {
    name: MerchantStatusText.WAITING,
    value: MerchantStatus.WAITING,
  },
  {
    name: MerchantStatusText.REJECT,
    value: MerchantStatus.REJECT,
  },
]

export const merchantIndividualDocs = [
  {
    name: 'บัตรประจำตัวประชาชน',
    key: 'document_personal_id',
  },
  {
    name: 'รูปเจ้าของร้านคู่บัตรประจำตัวประชาชน',
    key: 'document_personal_picture',
  },
  {
    name: 'สมุดบัญชี',
    key: 'document_bank',
  },
]

export const merchantCoporateDocs = [
  {
    name: 'สมุดบัญชี',
    key: 'document_bank',
  },
  {
    name: 'หนังสือรับรองบริษัท',
    key: 'document_company_certificate',
  },
  {
    name: 'สำเนาทะเบียนการค้า',
    key: 'document_commercial_registration',
  },
  {
    name: 'ภพ. 20',
    key: 'document_commercial_copy_of_vat',
  },
  {
    name: 'เลขที่ผู้เสียภาษี',
    key: 'document_company_tax_id',
  },
]

export enum CreatedByText {
  MERCHANT = 'ร้านค้า',
  SYSTEM = 'ระบบ',
}

// manufacurers
export enum ManufacurerStatus {
  PUBLISH = 'publish',
  UNPUBLISH = 'unpublish',
  DRAFT = 'draft',
}

export enum ManufacurerStatusText {
  PUBLISH = 'เปิดใช้งาน',
  UNPUBLISH = 'ปิดใช้งาน',
  DRAFT = 'แบบร่าง',
}

export const menuManufacurerStatus = [
  {
    name: ManufacurerStatusText.DRAFT,
    value: ManufacurerStatus.DRAFT,
  },
  {
    name: ManufacurerStatusText.PUBLISH,
    value: ManufacurerStatus.PUBLISH,
  },
  {
    name: ManufacurerStatusText.UNPUBLISH,
    value: ManufacurerStatus.UNPUBLISH,
  },
]

// categories
export enum CategoriesStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export enum CategoriesStatusText {
  ACTIVE = 'เปิดใช้งาน',
  INACTIVE = 'ปิดใช้งาน',
}

export const menuCategoriesStatus = [
  {
    name: CategoriesStatusText.ACTIVE,
    value: CategoriesStatus.ACTIVE,
  },
  {
    name: CategoriesStatusText.INACTIVE,
    value: CategoriesStatus.INACTIVE,
  },
]

export enum Config {
  TENMB_UPLOAD_FILE_SIZE_BYTES = 10000000, // 10MB
  FIVEMB_UPLOAD_FILE_SIZE_BYTES = 5000000, // 5MB
  ONEMB_UPLOAD_FILE_SIZE_BYTES = 1000000, // 1MB
  FIVEKB_UPLOAD_FILE_SIZE_BYTES = 500000, // 500KB
}

// product
export enum ProductStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export enum ProductStatusText {
  ACTIVE = 'เปิดใช้งาน',
  INACTIVE = 'ปิดใช้งาน',
}

export const menuProductStatus = [
  {
    name: ProductStatusText.ACTIVE,
    value: ProductStatus.ACTIVE,
  },
  {
    name: ProductStatusText.INACTIVE,
    value: ProductStatus.INACTIVE,
  },
]

export enum ProductCreatedBy {
  IMPORT = 'import',
  ADD = 'create',
  FILE = 'file',
}

export enum ProductCreatedByText {
  IMPORT = 'นำเข้า',
  ADD = 'เพิ่มสินค้า',
  FILE = 'นำเข้าจากไฟล์',
}

export enum ProductRequestStatus {
  PENDING = 'pending',
  APPROVED = 'approved',
  REJECTED = 'rejected',
  CANCELLED = 'cancelled',
}

export enum ProductRequestStatusText {
  PENDING = 'รออนุมัติ',
  APPROVED = 'อนุมัติ',
  REJECTED = 'ไม่อนุมัติ',
  CANCELLED = 'ยกเลิก',
}

export const menuProductRequestStatus = [
  {
    name: ProductRequestStatusText.PENDING,
    value: ProductRequestStatus.PENDING,
  },
  {
    name: ProductRequestStatusText.APPROVED,
    value: ProductRequestStatus.APPROVED,
  },
  {
    name: ProductRequestStatusText.REJECTED,
    value: ProductRequestStatus.REJECTED,
  },
]

export const menuShipingType = [
  {
    name: 'ส่งฟรี ',
    value: 'free_delivery',
  },
  {
    name: 'รับสินค้าหน้าร้าน',
    value: 'pickup',
  },
  {
    name: 'ร้านค้าจัดส่งเอง',
    value: 'shop_delivery',
  },
  {
    name: 'ขนส่งสาธารณะ',
    value: 'public_delivery',
  },
  {
    name: 'สินค้าจัดส่งแบบพิเศษ เช่น รถคอนกรีต',
    value: 'special_delivery',
  },
]

export const menuUnitDate = [
  {
    name: 'วัน',
    value: 'days',
  },
  {
    name: 'เดือน',
    value: 'months',
  },
  {
    name: 'ปี',
    value: 'year',
  },
]

export const menuMasterProductStatus = [
  {
    name: 'สินค้าทั้งหมด',
    value: 0,
  },
  {
    name: 'สินค้าที่ยังไม่ได้นำเข้า',
    value: 1,
  },
]

export const menuAllProductStatus = [
  {
    name: 'แสดงสินค้าทั้งหมด',
    value: 1,
  },
  {
    name: 'แสดงเฉพาะสินค้าที่เลือก',
    value: 2,
  },
]

export enum DeliveryCostType {
  VARIABLE_PRICE = 'ตาม{type}',
  FIXED_PRICE = 'เหมาจ่าย',
  FIXED_VARIABLE_PRICE = 'ขั้นต่ำ+ตาม{type}',
}

export enum DeliveryCostTypeID {
  VARIABLE_PRICE = 1,
  FIXED_PRICE = 2,
  FIXED_VARIABLE_PRICE = 3,
}

export const menuDeliveryCostType = [
  {
    name: DeliveryCostType.VARIABLE_PRICE,
    value: DeliveryCostTypeID.VARIABLE_PRICE,
  },
  {
    name: DeliveryCostType.FIXED_PRICE,
    value: DeliveryCostTypeID.FIXED_PRICE,
  },
  {
    name: DeliveryCostType.FIXED_VARIABLE_PRICE,
    value: DeliveryCostTypeID.FIXED_VARIABLE_PRICE,
  },
]

export enum OrderStatus {
  ALL = 'all',
  PENDING = 'pending',
  SUCCESS = 'success',
  CONFIRMED = 'confirmed',
  ON_DELIVERY = 'on_delivery',
  DELIVERED = 'delivered',
  CONFIRM_RECEICVED = 'confirm_received',
  CANCEL = 'cancel',
}

export enum OrderStatusText {
  ALL = 'ทั้งหมด',
  PENDING = 'รอการชำระเงิน',
  SUCCESS = 'รายการสั่งซื้อใหม่',
  CONFIRMED = 'เตรียมจัดส่ง',
  ON_DELIVERY = 'อยู่ระหว่างจัดส่ง',
  DELIVERED = 'รายการที่สำเร็จ',
  CONFIRM_RECEICVED = 'รายการที่สำเร็จ',
  CANCEL = 'รายการที่ยกเลิก',
}

export enum OrderStatusShortText {
  ALL = 'ทั้งหมด',
  PENDING = 'รอชำระเงิน',
  SUCCESS = 'รายการสั่งซื้อใหม่',
  CONFIRMED = 'เตรียมจัดส่ง',
  ON_DELIVERY = 'อยู่ระหว่างจัดส่ง',
  DELIVERED = 'สำเร็จ',
  CONFIRM_RECEICVED = 'สำเร็จ',
  CANCEL = 'ยกเลิก',
}

export const menuOrderStatus = [
  {
    name: OrderStatusText.ALL,
    value: OrderStatus.ALL,
  },
  {
    name: OrderStatusText.PENDING,
    value: OrderStatus.PENDING,
  },
  {
    name: OrderStatusText.SUCCESS,
    value: OrderStatus.SUCCESS,
  },
  {
    name: OrderStatusText.CONFIRMED,
    value: OrderStatus.CONFIRMED,
  },
  {
    name: OrderStatusText.ON_DELIVERY,
    value: OrderStatus.ON_DELIVERY,
  },
  {
    name: OrderStatusText.DELIVERED,
    value: OrderStatus.DELIVERED,
  },
  {
    name: OrderStatusText.CANCEL,
    value: OrderStatus.CANCEL,
  },
]

export const logsOrderStatus = [
  {
    name: 'รายการสั่งซื้อ',
    value: 'order success',
  },
  {
    name: 'รายการชำระเงิน',
    value: 'payment success',
  },
  {
    name: 'รายการเตรียมจัดส่ง',
    value: 'accept your order',
  },
  {
    name: 'รายการอยู่ระหว่างการจัดส่ง',
    value: 'on shipping',
  },
  {
    name: 'รายการที่สำเร็จ',
    value: 'has been delivered',
  },
  {
    name: 'ลูกค้ายืนยันรับสินค้า',
    value: 'already',
  },
]

export const logsCreditTermStatus = [
  ...logsOrderStatus,
  {
    name: 'รับชำระเครดิตเทอมสำเร็จ',
    value: 'credit term has been paid',
  },
]

export enum PaymentType {
  CREDIT = 'credit_card',
  COD = 'cod',
  CASH = 'cash',
  PP = 'promptpay',
  POS = 'cash_pos',
  TRANSFER_POS = 'transfer_pos',
  TRANSFER_QR = 'qr_payment',
  TRANSFER_CREDIT_TERM = 'credit_term',
}

export enum PaymentTypeText {
  CREDIT = 'บัตรเครดิต',
  COD = 'เก็บเงินปลายทาง',
  CASH = 'ชำระหน้าร้าน',
  PP = 'พร้อมเพย์',
  POS = 'เงินสด (Terminal)',
  TRANSFER_POS = 'เงินโอน (Terminal)',
  TRANSFER_QR = 'เงินโอนผ่าน QR (Terminal)',
  TRANSFER_CREDIT_TERM = 'เครดิตเทอม (Terminal)',
}

export const menuPaymentType = [
  {
    value: PaymentType.PP,
    name: PaymentTypeText.PP,
  },
  {
    value: PaymentType.COD,
    name: PaymentTypeText.COD,
  },
  {
    value: PaymentType.CREDIT,
    name: PaymentTypeText.CREDIT,
  },
  {
    value: PaymentType.CASH,
    name: PaymentTypeText.CASH,
  },
]

export const menuPaymentTypePackageC = [
  {
    value: PaymentType.PP,
    name: PaymentTypeText.PP,
  },
  {
    value: PaymentType.COD,
    name: PaymentTypeText.COD,
  },
  {
    value: PaymentType.CREDIT,
    name: PaymentTypeText.CREDIT,
  },
  {
    value: PaymentType.CASH,
    name: PaymentTypeText.CASH,
  },
  {
    value: PaymentType.POS,
    name: PaymentTypeText.POS,
  },
  {
    value: PaymentType.TRANSFER_POS,
    name: PaymentTypeText.TRANSFER_POS,
  },
  {
    value: PaymentType.TRANSFER_QR,
    name: PaymentTypeText.TRANSFER_QR,
  },
  {
    value: PaymentType.TRANSFER_CREDIT_TERM,
    name: PaymentTypeText.TRANSFER_CREDIT_TERM,
  },
  // {
  //   value: PaymentType.TRANSFER_QR,
  //   name: PaymentTypeText.TRANSFER_QR,
  // },
  // {
  //   value: PaymentType.TRANSFER_CREDIT_TERM,
  //   name: PaymentTypeText.TRANSFER_CREDIT_TERM,
  // },
]

export const menuPaymentTypePackageCWithoutOnline = [
  {
    value: PaymentType.POS,
    name: PaymentTypeText.POS,
  },
  {
    value: PaymentType.TRANSFER_POS,
    name: PaymentTypeText.TRANSFER_POS,
  },
  {
    value: PaymentType.TRANSFER_QR,
    name: PaymentTypeText.TRANSFER_QR,
  },
  {
    value: PaymentType.TRANSFER_CREDIT_TERM,
    name: PaymentTypeText.TRANSFER_CREDIT_TERM,
  },
]

export const menuPaymentTypeForUpdate = [
  {
    value: PaymentType.POS,
    name: PaymentTypeText.POS,
  },
  {
    value: PaymentType.TRANSFER_POS,
    name: PaymentTypeText.TRANSFER_POS,
  },
]

export enum DeliveryType {
  PUBLIC = 'public_delivery',
  SHOP = 'shop_delivery',
  FREE = 'free_delivery',
  PICKUP = 'pickup',
}

export enum DeliveryTypeText {
  PUBLIC = 'ขนส่งสาธารณะ',
  SHOP = 'ร้านค้าจัดส่งเอง',
  FREE = 'ส่งฟรี',
  PICKUP = 'รับสินค้าหน้าร้าน',
}

export const menuDeliveryType = [
  {
    value: DeliveryType.PUBLIC,
    name: DeliveryTypeText.PUBLIC,
  },
  {
    value: DeliveryType.SHOP,
    name: DeliveryTypeText.SHOP,
  },
  {
    value: DeliveryType.FREE,
    name: DeliveryTypeText.FREE,
  },
  {
    value: DeliveryType.PICKUP,
    name: DeliveryTypeText.PICKUP,
  },
]

export enum DashboardDataType {
  SALE = 'sale',
  ORDER = 'order',
}

export enum PosMenu {
  USER = 'user',
  PACKAGE = 'package',
  TERMINAL = 'terminal',
  PAYMENT_CHANNEL = 'payment_channel',
}

//config constant for user
export enum UserStatusText {
  ACTIVE = 'อนุญาต',
  INACTIVE = 'ไม่อนุญาต',
}

export enum StaffStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export const ImageFallback = DefaultImage

//config menu for banner
export const menuAdsCloseBtnPosition = [
  {
    name: 'ด้านบนของรูปภาพ',
    value: 'top',
  },
  {
    name: 'ด้านล่างของรูปภาพ',
    value: 'bottom',
  },
]

export enum AdsStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export const passwordFormatConfig = [
  {
    name: 'อักษรภาษาอังกฤษตัวพิมพ์ใหญ่ (A-Z)',
    value: 'uppercase',
  },
  {
    name: 'อักษรภาษาอังกฤษตัวพิมพ์เล็ก (a-z)',
    value: 'lowercase',
  },
  {
    name: 'ตัวเลขอย่างน้อย 1 ตัว (0-9)',
    value: 'number',
  },
  {
    name: 'สัญลักษณ์พิเศษอย่างน้อย 1 ตัว (-!$%@^&*#()_+|~=`{}[]:”;’<>?,./)',
    value: 'sign',
  },
  {
    name: 'ความยาวขั้นต่ำ 8 ตัวอักษร',
    value: 'length',
  },
]

export const menuBankAccount = [
  {
    name: 'ธนาคารกรุงเทพ',
    value: 'BBL',
  },
  {
    name: 'ธนาคารกรุงไทย',
    value: 'KTB',
  },
  {
    name: 'ธนาคารกสิกรไทย',
    value: 'KBANK',
  },
  {
    name: 'ธนาคารทหารไทย',
    value: 'TMB',
  },
  {
    name: 'ธนาคารทิสโก้',
    value: 'TISCO',
  },
  {
    name: 'ธนาคารไทยพาณิชย์',
    value: 'SCB',
  },
  {
    name: 'ธนาคารออมสิน',
    value: 'GSB',
  },
  {
    name: 'ธนาคารอาคารสงเคราะห์',
    value: 'GHB',
  },
  {
    name: 'ธนาคารกรุงศรีอยุธยา',
    value: 'BAY',
  },
  {
    name: 'ธนาคารเพื่อการเกษตรและสหกรณ์การเกษตร',
    value: 'BAAC',
  },
]

//purchase

export enum PurchaseStatus {
  DRAFT = 'draft',
  PENDING = 'pending',
  PARTIAL_RECEIPT = 'partial_receipt',
  SUCCESS = 'success',
  CONDITION_RECEIPT = 'condition_receipt',
  CANCEL = 'cancel',
}

export enum PurchaseStatusText {
  DRAFT = 'แบบร่าง',
  PENDING = 'รอรับสินค้า',
  PARTIAL_RECEIPT = 'รับแล้วบางส่วน',
  SUCCESS = 'สำเร็จ',
  CONDITION_RECEIPT = 'สำเร็จมีเงื่อนไข',
  CANCEL = 'ยกเลิก',
}

export const menuPurchaseStatus = [
  {
    name: 'ทั้งหมด',
    value: '',
  },
  {
    name: PurchaseStatusText.DRAFT,
    value: PurchaseStatus.DRAFT,
  },
  {
    name: PurchaseStatusText.PENDING,
    value: PurchaseStatus.PENDING,
  },
  {
    name: PurchaseStatusText.PARTIAL_RECEIPT,
    value: PurchaseStatus.PARTIAL_RECEIPT,
  },
  {
    name: PurchaseStatusText.SUCCESS,
    value: PurchaseStatus.SUCCESS,
  },
  {
    name: PurchaseStatusText.CONDITION_RECEIPT,
    value: PurchaseStatus.CONDITION_RECEIPT,
  },
  {
    name: PurchaseStatusText.CANCEL,
    value: PurchaseStatus.CANCEL,
  },
]

export enum OverStockStatus {
  DRAFT = 'draft',
  PENDING = 'pending',
  SUCCESS = 'success',
}

export enum OverStockStatusText {
  DRAFT = 'รอระบุข้อมูล',
  PENDING = 'รอรับสินค้าเข้าคลัง',
  SUCCESS = 'สำเร็จ',
}

export const menuPurchaseOverStockStatus = [
  {
    name: 'ทั้งหมด',
    value: '',
  },
  {
    name: OverStockStatusText.SUCCESS,
    value: OverStockStatus.SUCCESS,
  },
  {
    name: OverStockStatusText.DRAFT,
    value: OverStockStatus.DRAFT,
  },
  {
    name: OverStockStatusText.PENDING,
    value: OverStockStatus.PENDING,
  },
]

export const menuPurchasPickupStatus = [
  {
    name: 'ทั้งหมด',
    value: '',
  },
  {
    name: PurchaseStatusText.PENDING,
    value: PurchaseStatus.PENDING,
  },
  {
    name: PurchaseStatusText.PARTIAL_RECEIPT,
    value: PurchaseStatus.PARTIAL_RECEIPT,
  },
]

// DefaultStatusText
export enum DefaultStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export enum DefaultStatusText {
  ACTIVE = 'เปิดใช้งาน',
  INACTIVE = 'ปิดใช้งาน',
}

export const menuDefaultStatus = [
  {
    name: DefaultStatusText.ACTIVE,
    value: DefaultStatus.ACTIVE,
  },
  {
    name: DefaultStatusText.INACTIVE,
    value: DefaultStatus.INACTIVE,
  },
]

// DefaultStatusText
export enum PaymentTypes {
  CASH = 'cash',
  TRANSFER = 'transfer',
  CREDIT = 'credit',
  CHECK = 'cheque',
  VOID = 'void',
}

export enum PaymentTypesText {
  CASH = 'เงินสด',
  TRANSFER = 'เงินโอน',
  CREDIT = 'บัตรเครดิต',
  CHECK = 'เช็ค',
  RETURN_CREDIT = 'คืนเครดิต',
  VOID = 'คืนสินค้า',
}

export const menuSupplierPaymentTypes = [
  {
    name: PaymentTypesText.CASH,
    value: PaymentTypes.CASH,
  },
  {
    name: PaymentTypesText.TRANSFER,
    value: PaymentTypes.TRANSFER,
  },
  {
    name: PaymentTypesText.CREDIT,
    value: PaymentTypes.CREDIT,
  },
  {
    name: PaymentTypesText.CHECK,
    value: PaymentTypes.CHECK,
  },
]

export const menuReturnPaymentTypes = [
  {
    name: PaymentTypesText.CASH,
    value: PaymentTypes.CASH,
  },
  {
    name: PaymentTypesText.TRANSFER,
    value: PaymentTypes.TRANSFER,
  },
  {
    name: PaymentTypesText.CREDIT,
    value: 'creditcard',
  },
  {
    name: PaymentTypesText.CHECK,
    value: PaymentTypes.CHECK,
  },
  {
    name: PaymentTypesText.RETURN_CREDIT,
    value: 'credit',
  },
]

export const menuReturnReason = [
  {
    name: 'ได้รับสินค้าไม่ครบ / ชิ้นส่วนไม่ครบ',
    value: 'ได้รับสินค้าไม่ครบ / ชิ้นส่วนไม่ครบ',
  },
  {
    name: 'ได้รับสินค้าไม่ตรงตามที่สั่ง เช่น ขนาดผิด สีผิด สินค้าผิด',
    value: 'ได้รับสินค้าไม่ตรงตามที่สั่ง เช่น ขนาดผิด สีผิด สินค้าผิด',
  },
  {
    name: 'สินค้าสภาพไม่ดีหรือมีความชำรุดเสียหาย',
    value: 'สินค้าสภาพไม่ดีหรือมีความชำรุดเสียหาย',
  },
  {
    name: 'เหตุผลอื่นๆ ระบุ',
    value: 'other',
  },
]

export const menuReturnChannel = [
  {
    name: 'Terminal',
    value: 'pos',
  },
  {
    name: 'ระบบขายราคาพิเศษ',
    value: 'supplier',
  },
]
//GRAN

export enum GrnStatus {
  ALL = 'all',
  PENDING = 'pending',
  SUCCESS = 'success',
  EXPIRED = 'expired',
  PATIAL = 'partial_success',
}

export enum GrnStatusText {
  ALL = 'ทั้งหมด',
  EXPIRED = 'ใกล้ถึงกำหนดชำระ',
  PENDING = 'รอชำระหนี้',
  SUCCESS = 'ชำระสำเร็จ',
  PATIAL = 'ชำระแล้วบางส่วน',
}

export const menuGrnStatus = [
  {
    name: GrnStatusText.EXPIRED,
    value: GrnStatus.EXPIRED,
  },
  {
    name: GrnStatusText.PENDING,
    value: GrnStatus.PENDING,
  },
  {
    name: GrnStatusText.PATIAL,
    value: GrnStatus.PATIAL,
  },
  {
    name: GrnStatusText.SUCCESS,
    value: GrnStatus.SUCCESS,
  },
]

export const menuPayDeptStatus = [
  {
    name: GrnStatusText.EXPIRED,
    value: GrnStatus.EXPIRED,
  },
  {
    name: GrnStatusText.PENDING,
    value: GrnStatus.PENDING,
  },
]

export const menuStock = [
  {
    name: 'สินค้าทั้งหมดในคลัง',
    value: '',
  },
  {
    name: 'แจ้งเตือนสินค้าใกล้หมด',
    value: 'min_of_stock',
  },
  {
    name: 'สินค้าหมด',
    value: 'out_of_stock',
  },
]

export const menuAdjustStock = [
  {
    name: 'ปรับจำนวนขาย Online / Offline',
    value: 'allocate',
  },
  {
    name: 'ปรับสินค้าออกจากสินค้าคงคลัง',
    value: 'stock',
  },
]

export const menuAdjustStockForBom = [
  {
    name: 'ปรับจำนวนขาย Online / Offline',
    value: 'allocate',
  },
]

//quotation

export enum QuotationStatus {
  DRAFT = 'draft',
  PENDING = 'pending',
  SUCCESS = 'success',
  CANCEL = 'cancel',
}

export enum QuotationStatusText {
  DRAFT = 'แบบร่าง',
  PENDING = 'รออนุมัติ',
  SUCCESS = 'สำเร็จ',
  CANCEL = 'ยกเลิก',
}

export const menuQuotationStatus = [
  {
    name: 'ทั้งหมด',
    value: '',
  },
  {
    name: QuotationStatusText.DRAFT,
    value: QuotationStatus.DRAFT,
  },
  {
    name: QuotationStatusText.PENDING,
    value: QuotationStatus.PENDING,
  },
  {
    name: QuotationStatusText.SUCCESS,
    value: QuotationStatus.SUCCESS,
  },
  {
    name: QuotationStatusText.CANCEL,
    value: QuotationStatus.CANCEL,
  },
]

//supplier order

export enum SupplierOrderStatus {
  PREPARE = 'prepare_delivery',
  ON_DELIVERY = 'on_delivery',
  DELIVERED = 'delivered',
}

export enum SupplierOrderStatusText {
  PREPARE = 'เตรียมจัดส่ง',
  ON_DELIVERY = 'อยู่ระหว่างจัดส่ง',
  DELIVERED = 'จัดส่งสำเร็จ',
}

export const menuSupplierOrderStatus = [
  {
    name: 'ทั้งหมด',
    value: '',
  },
  {
    name: SupplierOrderStatusText.PREPARE,
    value: SupplierOrderStatus.PREPARE,
  },
  {
    name: SupplierOrderStatusText.ON_DELIVERY,
    value: SupplierOrderStatus.ON_DELIVERY,
  },
  {
    name: SupplierOrderStatusText.DELIVERED,
    value: SupplierOrderStatus.DELIVERED,
  },
]

//supplier invoice

export enum SupplierInvoiceStatus {
  WAITING = 'waiting',
  SUCCESS = 'success',
  EXPIRED = 'expired',
  PAYMENT_PENDING = 'payment_pending',
  PATIAL = 'partial',
}

export enum SupplierInvoiceStatusText {
  WAITING = 'รอชำระเงิน',
  EXPIRED = 'ใกล้ถึงกำหนดชำระ',
  SUCCESS = 'ชำระสำเร็จ',
  PAYMENT_PENDING = 'อยู่ระหว่างรอยอดเงินเข้า',
  PATIAL = 'ชำระแล้วบางส่วน',
}

export const menuSupplierInvoiceStatus = [
  {
    name: 'ทั้งหมด',
    value: '',
  },
  // {
  //   name: SupplierInvoiceStatusText.EXPIRED,
  //   value: SupplierInvoiceStatus.EXPIRED,
  // },
  {
    name: SupplierInvoiceStatusText.WAITING,
    value: SupplierInvoiceStatus.WAITING,
  },
  {
    name: SupplierInvoiceStatusText.PATIAL,
    value: SupplierInvoiceStatus.PATIAL,
  },
  {
    name: SupplierInvoiceStatusText.PAYMENT_PENDING,
    value: SupplierInvoiceStatus.PAYMENT_PENDING,
  },
  {
    name: SupplierInvoiceStatusText.SUCCESS,
    value: SupplierInvoiceStatus.SUCCESS,
  },
]

export const menuSupplierInvoicePendingStatus = [
  {
    name: 'รอชำระเงินทั้งหมด',
    value: SupplierInvoiceStatus.WAITING,
  },
  {
    name: SupplierInvoiceStatusText.EXPIRED,
    value: SupplierInvoiceStatus.EXPIRED,
  },
]

export const menuSupplierInvoiceFilterStatus = [
  {
    name: 'ทั้งหมด',
    value: '',
  },
  {
    name: SupplierInvoiceStatusText.WAITING,
    value: SupplierInvoiceStatus.WAITING,
  },
  {
    name: SupplierInvoiceStatusText.PATIAL,
    value: SupplierInvoiceStatus.PATIAL,
  },
  {
    name: SupplierInvoiceStatusText.SUCCESS,
    value: SupplierInvoiceStatus.SUCCESS,
  },
]

//discount

export enum DiscountType {
  AMOUNT = 'amount',
  PERCENT = 'percent',
}

export enum DiscountText {
  AMOUNT = 'บาท',
  PERCENT = '%',
}

export const menuDiscountType = [
  {
    name: DiscountText.AMOUNT,
    value: DiscountType.AMOUNT,
  },
  {
    name: DiscountText.PERCENT,
    value: DiscountType.PERCENT,
  },
]

export const menuQuotationDeliveryType = [
  {
    value: DeliveryType.SHOP,
    name: DeliveryTypeText.SHOP,
  },
  {
    value: DeliveryType.PICKUP,
    name: DeliveryTypeText.PICKUP,
  },
]

export const menuPointTab = [
  {
    name: 'รายการแลกของรางวัล',
    value: 'burn',
  },
  {
    name: 'รายการสะสมคะแนน',
    value: 'earn',
  },
  {
    name: 'รายการคะแนนหมดอายุ',
    value: 'expired',
  },
]

export const menuPointUserType = [
  {
    value: 'buyer',
    name: 'ผู้ซื้อ',
  },
  {
    value: 'seller',
    name: 'ร้านค้า',
  },
]

export const menuBurnPointStatus = [
  {
    value: 'reserved',
    name: 'จอง',
  },
  {
    value: 'success',
    name: 'สำเร็จ',
  },
  {
    value: 'cancel',
    name: 'ยกเลิก',
  },
]

export const menuTax = [
  {
    name: 'ออกใบกำกับภาษีสำหรับลูกค้า',
    value: '1',
  },
  {
    name: 'ออกใบกำกับภาษีสำหรับขายราคาพิเศษ',
    value: '2',
  },
  {
    name: 'ใบกำกับภาษีทั้งหมด',
    value: '3',
  },
  {
    name: 'ข้อมูลร้านสำหรับออกใบกำกับภาษี',
    value: '4',
  },
]

export enum TaxInvoiceType {
  SUPPLIER = 'suppiler',
  CUSTOMER = 'customer',
}

export enum TaxInvoiceTypeText {
  SUPPLIER = 'ขายราคาพิเศษ',
  CUSTOMER = 'ลูกค้าทั่วไป',
}

export const menuTaxInvoiceType = [
  {
    name: 'ทั้งหมด',
    value: '',
  },
  {
    name: TaxInvoiceTypeText.CUSTOMER,
    value: TaxInvoiceType.CUSTOMER,
  },
  {
    name: TaxInvoiceTypeText.SUPPLIER,
    value: TaxInvoiceType.SUPPLIER,
  },
]

//Tax

//GRAN

export enum Taxtatus {
  SUCCESS = 'success',
  CANCEL = 'cancel',
}

export enum TaxtatusText {
  SUCCESS = 'สำเร็จ',
  CANCEL = 'ยกเลิก',
}

export const menuTaxtatus = [
  {
    name: 'ทั้งหมด',
    value: '',
  },
  {
    name: TaxtatusText.SUCCESS,
    value: Taxtatus.SUCCESS,
  },
  {
    name: TaxtatusText.CANCEL,
    value: Taxtatus.CANCEL,
  },
]

// Stock type

export enum StockMovementType {
  SALE = 'sales',
  RECEIPT = 'receipt',
  ADJUSTOUT = 'adjustment-out',
  VOID = 'void',
}

export enum StockMovementTypeText {
  SALE = 'ขายออก',
  RECEIPT = 'รับเข้า',
  ADJUSTOUT = 'ปรับออกจากคลัง',
  VOID = 'รับคืนสินค้า',
}

export const menuStockMovementType = [
  {
    name: StockMovementTypeText.SALE,
    value: StockMovementType.SALE,
  },
  {
    name: StockMovementTypeText.RECEIPT,
    value: StockMovementType.RECEIPT,
  },
  {
    name: StockMovementTypeText.ADJUSTOUT,
    value: StockMovementType.ADJUSTOUT,
  },
  {
    name: StockMovementTypeText.VOID,
    value: StockMovementType.VOID,
  },
]

// Stock channel
export enum StockMovementChannel {
  POS = 'pos',
  SUPPLIER = 'supplier',
  WEB = 'web',
  IOS = 'ios',
  ANDROIND = 'android',
}

export enum StockMovementChannelText {
  POS = `TERMINAL`,
  SUPPLIER = 'ระบบขายราคาพิเศษ',
  WEB = 'Web',
  IOS = 'iOS',
  ANDROIND = 'Android',
}

export const menuChannel = [
  {
    name: StockMovementChannel.POS,
    value: StockMovementChannelText.POS,
  },
  {
    name: StockMovementChannel.SUPPLIER,
    value: StockMovementChannelText.SUPPLIER,
  },
]

export const monthNames = {
  en: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  th: [
    'มกราคม',
    'กุมภาพันธ์',
    'มีนาคม',
    'เมษายน',
    'พฤษภาคม',
    'มิถุนายน',
    'กรกฎาคม',
    'สิงหาคม',
    'กันยายน',
    'ตุลาคม',
    'พฤศจิกายน',
    'ธันวาคม',
  ],
}

export const menuDateOptionFilter = [
  {
    name: 'ค้นหาด้วยวันที่',
    value: 'date',
  },
  {
    name: 'ค้นหาด้วยไตรมาส',
    value: 'quater',
  },
]

export const permissionGroup = [
  {
    name: 'แดชบอร์ด',
    value: ['ภาพรวมแดชบอร์ด', 'แดชบอร์ด Mini RMX', 'แดชบอร์ดภาพรวม Mini RMX'],
  },
  {
    name: 'พันธมิตรทางธุรกิจ',
    value: ['จัดการข้อมูลพันธมิตรทางธุรกิจ'],
  },
  {
    name: 'รายการอนุมัติสินค้า',
    value: ['จัดการข้อมูลการอนุมัติสินค้า'],
  },
  {
    name: 'รายการแคมเปญคูปอง',
    value: ['จัดการแคมเปญคูปอง'],
  },
  {
    name: 'รายการคะแนนสะสม',
    value: ['จัดการคะแนนสะสม'],
  },
  {
    name: 'รายการแบนเนอร์',
    value: ['จัดการไฮไลน์แบนเนอร์', 'จัดการโฆษณา Ads หน้าแรก'],
  },
  {
    name: 'จัดการข้อมูล',
    value: [
      'จัดการข้อมูลหมวดหมู่สินค้า',
      'จัดการข้อมูลผู้ผลิต',
      'จัดการข้อมูลผลิตภัณฑ์ต่อหน่วย',
      'จัดการข้อมูลคอนเท้นต์',
    ],
  },
  {
    name: 'ข้อมูลร้านค้า',
    value: ['จัดการข้อมูลร้านค้า'],
  },
  {
    name: 'ระบบขายหน้าร้าน',
    value: [
      'จัดการข้อมูลระบบช่วยขายหน้าร้าน (Terminal)',
      'จัดการเครื่อง TERMINAL',
      'ตั้งค่าช่องทางการรับชำระเงิน',
    ],
  },
  {
    name: 'ใบกำกับภาษีเต็มรูปแบบ',
    value: ['ออกใบกำกับภาษีรูปแบบเต็ม'],
  },
  {
    name: 'รายงานสินค้าคงคลัง',
    value: [
      'ข้อมูลรายงานสินค้าคงคลัง',
      'ปรับจำนวนขาย ออนไลน์/ออฟไลน์',
      'ปรับสินค้าออกจากคลัง',
      'ตรวจสอบรายการนำเข้า',
      'การเคลื่อนไหวคลังสินค้า',
    ],
  },
  {
    name: 'รายงาน',
    value: [
      'รายงานคำสั่งซื้อ',
      'รายงานคำสั่งซื้อ(แบบเต็ม)',
      'รายงานข้อมูลสมาชิก',
      'รายงานข้อมูลระบบจัดซื้อ',
      'รายงานหนี้ของลูกค้า/คู่ค้า',
      'รายงานสินค้าคงเหลือ',
      'รายงานสินค้าคงเหลือ อ้างอิงตามใบกำกับภาษี',
    ],
  },
  {
    name: 'ตั้งค่า',
    value: [
      'ตั้งค่าขั้นต่ำสต๊อก/กำหนดรูปแบบราคาสินค้า',
      'ตั้งค่าการพิมพ์เอกสาร',
      'จัดการค่าขนส่งโดยร้านค้า',
      'แจ้งเตือนสต๊อกขั้นต่ำ',
    ],
  },
  {
    name: 'รายการสั่งซื้อ',
    value: ['จัดการคำสั่งซื้อ', 'ปฏิเสธรายการสั่งซื้อ', 'เปลี่ยนสถานะคำสั่งซื้อจาก TERMINAL อัตโนมัติ'],
  },
  {
    name: 'รับคืนรายการสินค้า',
    value: ['จัดการรายการรับคืนสินค้า', 'สร้างรายการรับคืนสินค้า'],
  },
  {
    name: 'รายการสินค้า',
    value: [
      'จัดการข้อมูลสินค้า',
      'ลบรายการสินค้า',
      'จัดการราคาสินค้าโดยไม่ผ่านการอนุมัติ',
      'จัดการส่วนประกอบสินค้า',
      'นำเข้าสินค้าจากไฟล์',
      'สร้างสินค้าแบบหลายหน่วย',
    ],
  },
  {
    name: 'ระบบจัดซื้อ',
    value: ['ออกใบสั่งซื้อสินค้า', 'รับสินค้าเข้าคลัง', 'รายการจ่ายหนี้', 'ตั้งค่าข้อมูลบริษัท/Supplier'],
  },
  {
    name: 'ระบบเสนอขายราคาพิเศษ',
    value: [
      'ออกใบเสนอราคา',
      'สร้างรายการขาย',
      'เรียกเก็บหนี้',
      'รายการใบแจ้งหนี้/ใบวางบิล',
      'ลูกค้า/คู่ค้า',
      'ขายสินค้าเกินจำนวนสต๊อก',
      'ขายสินค้าที่ไม่มีในระบบ (None-SKU)',
      'ส่วนลดต่อรายการสินค้า (ระบบขายราคาพิเศษ)',
    ],
  },
  {
    name: 'คะแนน/ของรางวัล',
    value: ['จัดการของรางวัล', 'จัดการสมาชิก', 'การสะสมคะแนน/แลกของรางวัล', 'ตั้งค่าการสะสมคะแนน'],
  },
  {
    name: 'จัดการสมาชิก',
    value: ['แก้ไขข้อมูลสมาชิก', 'จัดการคะแนนสมาชิก', 'แลกของรางวัล', 'ดูประวัติการสะสมคะแนน'],
  },
]

//return

export enum ReturnStatus {
  DRAFT = 'draft',
  PENDING = 'pending',
  SUCCESS = 'success',
}

export enum ReturnStatusText {
  DRAFT = 'รอคืนสินค้า',
  PENDING = 'รอคืนเงิน',
  SUCCESS = 'คืนเงินสำเร็จ',
}

export const menuReturnStatus = [
  {
    name: 'ทั้งหมด',
    value: '',
  },
  {
    name: ReturnStatusText.DRAFT,
    value: ReturnStatus.DRAFT,
  },
  {
    name: ReturnStatusText.PENDING,
    value: ReturnStatus.PENDING,
  },
  {
    name: ReturnStatusText.SUCCESS,
    value: ReturnStatus.SUCCESS,
  },
]

//permission
//return

export enum RoleMerchantType {
  POS = 'pos',
  STORE = 'store',
  STORE_SPECIAL = 'store_special',
  STORE_PACKAGE = 'store_package',
  STORE_RMX = 'store_rmx',
  STORE_RMX_OVERALL = 'store_rmx_overall',
  STORE_OVERSTOCK = 'store_overstock',
  STORE_NONE_SKU = 'store_none_sku',
  STORE_QUOTATION_VAT = 'store_quotation_vat',
  STORE_UOMS = 'store_multi_uom',
}

export enum RoleMerchantTypeText {
  POS = 'Pos',
  STORE = 'Store',
  STORE_SPECIAL = 'Store Special',
  STORE_PACKAGE = 'Store Package',
  STORE_RMX = 'Store Rmx',
  STORE_RMX_OVERALL = 'Store Rmx Overall',
  STORE_OVERSTOCK = 'Store Over Stock',
  STORE_NONE_SKU = 'Store None Sku',
  STORE_QUOTATION_VAT = 'Store Quotation Vat',
  STORE_UOMS = 'Store Multi Uom',
}

export const menuRoleMerchantType = [
  {
    name: RoleMerchantTypeText.POS,
    value: RoleMerchantType.POS,
  },
  {
    name: RoleMerchantTypeText.STORE,
    value: RoleMerchantType.STORE,
  },
  {
    name: RoleMerchantTypeText.STORE_SPECIAL,
    value: RoleMerchantType.STORE_SPECIAL,
  },
  {
    name: RoleMerchantTypeText.STORE_PACKAGE,
    value: RoleMerchantType.STORE_PACKAGE,
  },
  {
    name: RoleMerchantTypeText.STORE_RMX,
    value: RoleMerchantType.STORE_RMX,
  },
  {
    name: RoleMerchantTypeText.STORE_RMX_OVERALL,
    value: RoleMerchantType.STORE_RMX_OVERALL,
  },
  {
    name: RoleMerchantTypeText.STORE_OVERSTOCK,
    value: RoleMerchantType.STORE_OVERSTOCK,
  },
  {
    name: RoleMerchantTypeText.STORE_NONE_SKU,
    value: RoleMerchantType.STORE_NONE_SKU,
  },
  {
    name: RoleMerchantTypeText.STORE_UOMS,
    value: RoleMerchantType.STORE_UOMS,
  },
  // {
  //   name: RoleMerchantTypeText.STORE_QUOTATION_VAT,
  //   value: RoleMerchantType.STORE_QUOTATION_VAT,
  // },
]

export const menuMerchantTypeSpecailConfig = [
  {
    name: RoleMerchantTypeText.STORE_RMX,
    value: 'rmx',
  },
  {
    name: RoleMerchantTypeText.STORE_RMX_OVERALL,
    value: 'rmx_overall',
  },
  {
    name: RoleMerchantTypeText.STORE_OVERSTOCK,
    value: RoleMerchantType.STORE_OVERSTOCK,
  },
  {
    name: RoleMerchantTypeText.STORE_NONE_SKU,
    value: RoleMerchantType.STORE_NONE_SKU,
  },
  {
    name: RoleMerchantTypeText.STORE_UOMS,
    value: RoleMerchantType.STORE_UOMS,
  },
  // {
  //   name: RoleMerchantTypeText.STORE_QUOTATION_VAT,
  //   value: RoleMerchantType.STORE_QUOTATION_VAT,
  // },
]

export const menuMethod = [
  {
    name: 'GET',
    value: 'GET',
  },
  {
    name: 'POST',
    value: 'POST',
  },
  {
    name: 'PUT',
    value: 'PUT',
  },
  {
    name: 'DELETE',
    value: 'DELETE',
  },
  {
    name: 'OPTIONS',
    value: 'OPTIONS',
  },
]

export const menuVatType = [
  {
    name: 'ไม่มีภาษี',
    value: 100,
  },
  {
    name: 'ภาษีมูลค่าเพิ่ม 7%',
    value: 7,
  },
]

export const menuProductMaterialType = [
  {
    name: 'สินค้าไม่มีส่วนประกอบ',
    value: 100,
  },
  {
    name: 'สินค้ามีส่วนประกอบ',
    value: 1,
  },
]

export const menuUserGroup = [
  {
    name: 'ทั้งหมด',
    value: '',
  },
  {
    name: 'แฟรนไชส์',
    value: 'franchise',
  },
]

export const menuTaxSignType = [
  {
    // name: 'ผู้รับสินค้า/RECEIVED BY',
    // value: 'ผู้รับสินค้า/RECEIVED BY',
    name: 'ผู้รับสินค้า',
    value: 'ผู้รับสินค้า',
    isDefault: true,
  },
  {
    // name: 'ผู้รับเงิน/PAYEE BY',
    // value: 'ผู้รับเงิน/PAYEE BY',
    name: 'ผู้รับเงิน',
    value: 'ผู้รับเงิน',
    isDefault: true,
  },
  {
    // name: 'ผู้ส่งสินค้า/DELIVERED BY',
    // value: 'ผู้ส่งสินค้า/DELIVERED BY',
    name: 'ผู้ส่งสินค้า',
    value: 'ผู้ส่งสินค้า',
  },
  {
    // name: 'ผู้จัดทำ/PREPARED BY',
    // value: 'ผู้จัดทำ/PREPARED BY',
    name: 'ผู้จัดทำ',
    value: 'ผู้จัดทำ',
  },
  {
    // name: 'ผู้ตรวจสอบ/CHECKED BY',
    // value: 'ผู้ตรวจสอบ/CHECKED BY',
    name: 'ผู้ตรวจสอบ',
    value: 'ผู้ตรวจสอบ',
  },
  {
    // name: 'ผู้มีอำนาจลงนาม/AUTHORIZED SIGNATURE',
    // value: 'ผู้มีอำนาจลงนาม/AUTHORIZED SIGNATURE',
    name: 'ผู้มีอำนาจลงนาม',
    value: 'ผู้มีอำนาจลงนาม',
  },
]

export const menuDeliverySignType = [
  {
    // name: 'ผู้รับสินค้า/RECEIVED BY',
    // value: 'ผู้รับสินค้า/RECEIVED BY',
    name: 'ผู้รับสินค้า',
    value: 'ผู้รับสินค้า',
    isDefault: true,
  },
  {
    // name: 'ผู้ส่งสินค้า/DELIVERED BY',
    // value: 'ผู้ส่งสินค้า/DELIVERED BY',
    name: 'ผู้ส่งสินค้า',
    value: 'ผู้ส่งสินค้า',
    isDefault: true,
  },
  {
    // name: 'ผู้มีอำนาจลงนาม/AUTHORIZED SIGNATURE',
    // value: 'ผู้มีอำนาจลงนาม/AUTHORIZED SIGNATURE',
    name: 'ผู้มีอำนาจลงนาม',
    value: 'ผู้มีอำนาจลงนาม',
  },
]

export const menuQuotationSignType = [
  {
    // name: 'ผู้รับสินค้า/RECEIVED BY',
    // value: 'ผู้รับสินค้า/RECEIVED BY',
    name: 'ผู้อนุมัติซื้อ',
    value: 'ผู้อนุมัติซื้อ',
    isDefault: true,
  },
  {
    // name: 'ผู้ส่งสินค้า/DELIVERED BY',
    // value: 'ผู้ส่งสินค้า/DELIVERED BY',
    name: 'ผู้เสนอราคา',
    value: 'ผู้เสนอราคา',
    isDefault: true,
  },
  {
    // name: 'ผู้มีอำนาจลงนาม/AUTHORIZED SIGNATURE',
    // value: 'ผู้มีอำนาจลงนาม/AUTHORIZED SIGNATURE',
    name: 'ผู้ตรวจใบเสนอราคา',
    value: 'ผู้ตรวจใบเสนอราคา',
    isDefault: true,
  },
]

export const menuTaxHeader = [
  {
    name: 'ต้นฉบับใบกำกับภาษี / ใบเสร็จรับเงินมัดจำ',
    value: 'ต้นฉบับใบกำกับภาษี / ใบเสร็จรับเงินมัดจำ',
    isDefault: true,
  },
  {
    name: 'ต้นฉบับใบกำกับภาษี / ใบเสร็จรับเงิน',
    value: 'ต้นฉบับใบกำกับภาษี / ใบเสร็จรับเงิน',
    isDefault: true,
  },
  {
    name: 'ต้นฉบับใบกำกับภาษี / ใบส่งสินค้า',
    value: 'ต้นฉบับใบกำกับภาษี / ใบส่งสินค้า',
    isDefault: true,
  },
  {
    name: 'ต้นฉบับใบกำกับภาษี',
    value: 'ต้นฉบับใบกำกับภาษี',
    isDefault: true,
  },
]

export const NOT_SHOW_PRICE_TEXT = '(ไม่แสดงราคา)'
export const FORCE_SHOW_TAX_ID = '/ ใบกำกับภาษีอย่างย่อ'

export const menuDeliveryHeader = [
  {
    name: 'ใบเสร็จรับเงินมัดจำ / ใบส่งสินค้า',
    value: 'ใบเสร็จรับเงินมัดจำ / ใบส่งสินค้า',
    isDefault: true,
  },
  {
    name: 'ใบเสร็จรับเงิน / ใบส่งสินค้า',
    value: 'ใบเสร็จรับเงิน / ใบส่งสินค้า',
    isDefault: true,
  },
  {
    name: `ใบเสร็จรับเงิน ${FORCE_SHOW_TAX_ID}`,
    value: `ใบเสร็จรับเงิน ${FORCE_SHOW_TAX_ID}`,
    isDefault: true,
  },
  {
    name: 'ใบส่งสินค้า',
    value: 'ใบส่งสินค้า',
    isDefault: true,
  },
  {
    name: `ใบส่งสินค้า ${NOT_SHOW_PRICE_TEXT}`,
    value: `ใบส่งสินค้า ${NOT_SHOW_PRICE_TEXT}`,
    isDefault: true,
  },
]

export enum VAT_TYPE {
  EX = 'exclude',
  IN = 'include',
}

export enum VAT_TYPE_TEXT {
  EX = 'Excluded',
  IN = 'Included',
}

export enum DocumentConfigKey {
  COMMON = 'COMMON',
  TAX = 'TAX_DOCUMENT',
  DELIVERY = 'DELIVERY_DOCUMENT',
  QUOTATION = 'QUOTATION_DOCUMENT',
  VAT_TYPE = 'VAT_TYPE',
  BARCODE = 'BARCODE',
}

export enum DocumentDefaultTitle {
  COMMON = 'COMMON',
  TAX = 'ใบกำกับภาษี',
  DELIVERY = 'ใบส่งสินค้า',
  SALEORDER = 'ใบส่งสินค้า',
  BARCODE = 'บาร์โค้ดสินค้า',
}

export const menuDocumentConfig = [
  {
    name: 'ตั้งค่าเอกสาร',
    value: '4',
  },
  {
    name: 'ใบกำกับภาษี',
    value: '1',
  },
  {
    name: 'ใบส่งสินค้า',
    value: '2',
  },
  {
    name: 'ใบเสนอราคา',
    value: '3',
  },
  {
    name: 'บาร์โค้ดสินค้า',
    value: '5',
  },
]

export enum PointConfigType {
  AMOUNT = 'amount',
  QUANTITY = 'quantity',
}

export enum PointConfigTypeText {
  AMOUNT = 'สะสมคะแนนจากมูลค่ายอดซื้อสินค้า',
  QUANTITY = 'สะสมคะแนนจากจำนวนหน่วยสินค้า',
}

export const menuPointConfigTypeText = [
  {
    name: PointConfigTypeText.AMOUNT,
    value: PointConfigType.AMOUNT,
  },
  {
    name: PointConfigTypeText.QUANTITY,
    value: PointConfigType.QUANTITY,
  },
]

export enum PointAdjustType {
  EARN = 'earn',
  BURN = 'burn',
}

export enum PointAdjustTypeText {
  EARN = 'เพิ่มคะแนน',
  BURN = 'ลดคะแนน',
}

export const menuPointAdjustType = [
  {
    name: PointAdjustTypeText.EARN,
    value: PointAdjustType.EARN,
  },
  {
    name: PointAdjustTypeText.BURN,
    value: PointAdjustType.BURN,
  },
]

export const menuAdjustPointReason = [
  {
    name: 'เพิ่มคะแนนให้จากบิลครั้งที่แล้ว',
    value: 'เพิ่มคะแนนให้จากบิลครั้งที่แล้ว',
  },
  {
    name: 'เพิ่มคะแนนเนื่องจากเป็นลูกค้าประจำ/ซื้อบ่อย',
    value: 'เพิ่มคะแนนเนื่องจากเป็นลูกค้าประจำ/ซื้อบ่อย',
  },
  {
    name: 'ลดคะแนนเนื่องจากทำรายการผิดพลาด อื่นๆ',
    value: 'ลดคะแนนเนื่องจากทำรายการผิดพลาด อื่นๆ',
  },
  {
    name: 'เหตุผลอื่นๆ ระบุ',
    value: 'other',
  },
]

export enum PointConfigChanel {
  SUP = 'supplier',
  POS = 'pos',
}

export enum PointConfigChanelText {
  SUP = `ระบบขายราคาพิเศษ`,
  POS = 'เครื่องช่วยขายหน้าร้าน (Terminal)',
}

export const menuPointConfigChanel = [
  {
    name: PointConfigChanelText.POS,
    value: PointConfigChanel.POS,
  },
  {
    name: PointConfigChanelText.SUP,
    value: PointConfigChanel.SUP,
  },
]

export const menuMemberPointRedeemTab = [
  {
    name: 'รายการสะสมคะแนน',
    value: 'earn',
  },
  {
    name: 'รายการแลกของรางวัล',
    value: 'burn',
  },
]

export enum EarnPointType {
  MANUAL = 'manual',
  ORDER = 'order',
  ORDER_MANUAL = 'order_manual',
}

export enum EarnPointTypeTitle {
  MANUAL_D = 'คะแนนถูกลดจากการปรับคะแนน',
  MANUAL_I = 'ได้รับคะแนนเพิ่มจากการปรับคะแนน',
  ORDER = 'ได้รับคะแนนจากรายการขาย',
  ORDER_MANUAL = 'ได้รับคะแนนจากรายการขาย และมีการปรับคะแนนเพิ่มเติม',
}

export const menuFeeType = [
  {
    name: CouponTypeText.AMOUNT,
    value: CouponType.AMOUNT,
  },
  {
    name: CouponTypeText.PERCENT,
    value: CouponType.PERCENT,
  },
]

export enum DOCUMENT_LOGO_POSITION {
  L = 'left',
  C = 'center',
  R = 'right',
}

export const menuPaperSize = [
  {
    name: 'สติ้กเกอร์ขนาด 32 x 25 mm. (3 ดวง/แถว)',
    value: '1',
    spec: {
      w: 3.2,
      h: 2.48,
      row: 3,
      space: 0.2,
      paper: 10.4,
      bw: 7,
      bh: 200,
    },
  },
  {
    name: 'สติ้กเกอร์ขนาด 32 x 25 mm. (1 ดวง/แถว)',
    value: '6',
    spec: {
      w: 3.2,
      h: 2.48,
      row: 1,
      space: 0.2,
      paper: 3.2,
      bw: 5,
      bh: 200,
    },
  },
  {
    name: 'สติ้กเกอร์ขนาด 34 x 20 mm. (3 ดวงแถว)',
    value: '2',
    spec: {
      w: 3.4,
      h: 1.98,
      row: 3,
      space: 0,
      paper: 10.4,
      bw: 6,
      bh: 120,
      isCenter: true,
    },
  },
  {
    name: 'สติ้กเกอร์ขนาด 50 x 25 mm. (2 ดวง/แถว)',
    value: '3',
    spec: {
      w: 5,
      h: 2.48,
      row: 2,
      space: 0,
      paper: 10.4,
      isCenter: true,
      bw: 5,
      bh: 180,
    },
  },
  {
    name: 'สติ้กเกอร์ขนาด 50 x 25 mm. (1 ดวง/แถว)',
    value: '4',
    spec: {
      w: 5,
      h: 2.48,
      row: 1,
      space: 0,
      paper: 5.2,
      isCenter: true,
      bw: 7,
      bh: 180,
    },
  },
  {
    name: 'สติ้กเกอร์ขนาด 40 x 30 mm. (2 ดวง/แถว)',
    value: '5',
    spec: {
      w: 4,
      h: 2.98,
      row: 2,
      space: 0,
      paper: 8.4,
      bw: 6,
      bh: 180,
      isCenter: true,
    },
  },
]
